export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["LessThan"] = "<";
    FilterOperator["LessThanOrEqual"] = "<=";
    FilterOperator["GreaterThan"] = ">";
    FilterOperator["GreaterThanOrEqual"] = ">=";
    FilterOperator["Equal"] = "=";
    FilterOperator["NotEqual"] = "!=";
    FilterOperator["Like"] = "like";
    FilterOperator["NotLike"] = "not like";
    FilterOperator["In"] = "in";
    FilterOperator["NotIn"] = "not in";
})(FilterOperator || (FilterOperator = {}));
//# sourceMappingURL=filterOperator.js.map